import { DragOverlay } from "@dnd-kit/core";
import { Chip } from "@mui/material";
import { motion } from "motion/react";

import { useClinicArrivalDndDrag } from "@/stores/use-clinic-arrival-dnd";

function ClinicArrivalOverlay() {
    const drag = useClinicArrivalDndDrag();

    return (
        // Fullscreen tasks table sets an explicit z-index: 1000 on its fixed-position wrapper,
        // which otherwise paints above DragOverlay's default z-index (999).
        <DragOverlay dropAnimation={null} zIndex={1400}>
            {drag ? (
                <motion.div
                    initial={{ scale: 0.95, x: 0, rotate: 0 }}
                    animate={{ scale: 1.04, x: 80, rotate: -2 }}
                    transition={{ duration: 0.12 }}
                >
                    <Chip
                        label={drag.name}
                        variant="filled"
                        sx={{
                            fontWeight: 700,
                            fontSize: 13,
                            px: 1,
                            background: "linear-gradient(135deg,#0d9488,#0891b2)",
                            color: "#fff",
                            boxShadow: "0 16px 32px rgba(13,148,136,0.35)",
                            cursor: "grabbing",
                        }}
                    />
                </motion.div>
            ) : null}
        </DragOverlay>
    );
}

export default ClinicArrivalOverlay;
